import { memo } from 'react';
import PlayerClock from './PlayerClock';
import './ClockMonospace.css';

export interface ClockMonospaceProps {
  time: number;
  isActive: boolean;
  isLow: boolean;
}

export const ClockMonospace = memo<ClockMonospaceProps>(({ time, isActive, isLow }) => {
  const className = [
    'clock-monospace',
    isActive && 'clock-monospace--active',
    isLow && 'clock-monospace--low',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={className} data-testid="clock-monospace">
      <PlayerClock time={time} isActive={isActive} isLow={isLow} />
    </div>
  );
});

ClockMonospace.displayName = 'ClockMonospace';
